import {
  BooleanField,
  Datagrid,
  List,
  TextField,
  TextInput,
} from 'react-admin';

const searchFilters = [
  <TextInput source="name@ilike" alwaysOn label="Name" />,
];

export const CoronersList = () => (
  <List filters={searchFilters} perPage={50} sort={{ field: 'name', order: 'ASC' }}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="id" label="OCC ID" />
      <TextField source="name" />
      <TextField source="address" />
      <BooleanField source="active" />
    </Datagrid>
  </List>
);
